import React from 'react';
import { observer } from 'mobx-react';
import EditSubuserComponent from './Edit-subuser.component';
import useEditSubuser from './useEditSubuser';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { subusers, lang, state, handlers } = useEditSubuser(onClose);

    return (
        <>
            <EditSubuserComponent
                lang={lang.lang}
                loading={subusers.changePasswordLoading || subusers.loading}
                login={state.login}
                password={state.password}
                passwordError={state.passwordError}
                passwordConfirm={state.passwordConfirm}
                passwordConfirmError={state.passwordConfirmError}
                serverError={subusers.serverError}
                onPasswordChange={handlers.handlePasswordChange}
                onPasswordConfirmChange={handlers.handlePasswordConfirmChange}
                onSaveClick={handlers.handleSaveClick}
                onInputClick={handlers.handleInputClick}
                onKeyDown={handlers.handleKeyDown}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
            />
        </>
    );
};

const EditSubuserContainer = observer(Container);

export default EditSubuserContainer;
